import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import { AI_COLORS } from '../aiAnalyticsConstants';

import AskStatusIndicator from './AskStatusIndicator';
import InlineProgress from './InlineProgress';

export default function ThreadListItem({ thread, active, askPhase, opLabel, onSelect, onToggleFavorite, onDelete }) {
  return (
    <div className={`thread-item ${active ? 'active' : ''}`} onClick={() => onSelect(thread.id)}>
      <IconButton
        size="small"
        onClick={e => onToggleFavorite(e, thread)}
        title={thread.favorite ? 'Unfavorite' : 'Favorite'}
      >
        {thread.favorite ? (
          <StarIcon fontSize="small" sx={{ color: AI_COLORS.accent }} />
        ) : (
          <StarBorderIcon fontSize="small" />
        )}
      </IconButton>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" noWrap>
          {thread.title || `Thread ${thread.id}`}
        </Typography>
        {askPhase ? <AskStatusIndicator phase={askPhase} dense /> : opLabel && <InlineProgress label={opLabel} dense />}
      </Box>
      <IconButton size="small" onClick={e => onDelete(e, thread.id)} title="Delete">
        <DeleteIcon fontSize="small" />
      </IconButton>
    </div>
  );
}
